{
  "metafields_page": {
    "header": {
      "title": "Metafield Configuration",
      "description": "Metafields help enhance the functionality of SparkLayer by adding special fields that allow you to capture more data on your eCommerce platform.",
      "footer": "Learn more about metafields"
    },
    "note": "When metafields are enabled, they can only be edited or removed by accessing them within the settings of your eCommerce platform.",
    "group_product_variant": "Product Metafields",
    "group_customer": "Customer Metafields",
    "group_order": "Order Metafields",
    "enable": "Enable",
    "unsupported": {
      "title": "Metafields are not supported",
      "subtitle": "Metafields are only available on Shopify, WooCommerce and Magento."
    }
  },
  "platform_page": {
    "header": {
      "title": "Platform",
      "description": "Start by selecting which platform you'll be using SparkLayer on. Once you're connected, our team can help set things up.",
      "footer": "Learn more about platform settings",
      "learn_more": "Learn more"
    },
    "form": {
      "save": "Save",
      "select_platform": "Please select a platform before saving.",
      "success_connected": "Your selected platform is successfully connected",
      "completed_install_title": "Good news! You've successfully connected your {platform} store to SparkLayer and data synchronisation is now starting.",
      "completed_install_body": "There are a few more steps to complete before your store is ready.",
      "completed_install_cta": "Continue onboarding",
      "platforms": {
        "shopify": {
          "name": "Shopify",
          "specifics": "Works with all versions of Shopify, including Shopify Plus."
        },
        "bigcommerce": {
          "name": "BigCommerce",
          "specifics": "Compatible with BigCommerce Plus and higher plans."
        },
        "wix": {
          "name": "Wix",
          "specifics": "Works with all versions of Wix, including Editor and Studio."
        },
        "woocommerce": {
          "name": "WooCommerce (Early Access)",
          "specifics": "Works with WooCommerce 9+ & WordPress 6+ running on PHP 8.2+."
        },
        "magento": {
          "name": "Magento",
          "specifics": "Works with Magento 2.4.2+, running on PHP 7.4+."
        },
        "custom": {
          "name": "Other",
          "specifics": "Build your own integration with any other platform."
        }
      },
      "woocommerce_api_config": {
        "title": "WooCommerce API Configuration",
        "description": "The following configuration details are required to allow customers, orders and products to be synced between SparkLayer and your store."
      },
      "magento_api_config": {
        "title": "Magento API Configuration",
        "description": "The following credentials are required to allow settings, customers, orders and products to be synced between SparkLayer and your store."
      },
      "basic_auth": {
        "title": "Server Basic Authentication Credentials (optional)",
        "description": "If you require a username and password to access your wordpress site while in testing you can provide these here."
      }
    },
    "order_actions": {
      "title": "Shopify Order Actions",
      "auto_complete": {
        "label": "Auto-complete Shopify Draft orders",
        "description": "For manual payments that create draft orders, automatically convert these into completed orders."
      },
      "account_set_as_paid": "Payment on Account orders - automatically mark as paid.",
      "invoice_set_as_paid": "Payment by Invoice orders - automatically mark as paid.",
      "disable_invite": {
        "label": "Disable new customer invite email",
        "description": "For sales admins, when creating a new customer in Shopify, disable sending the customer invite email."
      },
      "create_draft": {
        "label": "Create Draft Order on calculate",
        "description": "Create a draft order when calculating checkout totals. Required for correct handling of line item tax or when using some third-party shipping apps such as Intuitive Shipping. When enabling this, you should inform the merchant that draft orders will be created with the tag \"b2b-pending\" when the customer reaches the shipping method selection step of the checkout."
      },
      "price_override": {
        "label": "Create Draft Orders with price overrides",
        "description": "Use Shopify's new ability to override prices on Draft Orders rather than applying discounts to yield correct B2B prices."
      }
    },
    "configurations": {
      "title": "Configurations",
      "metafields": {
        "label": "Configure metafields",
        "description": "Manage the SparkLayer metafields configured with your platform."
      },
      "company_sync": {
        "label": "Enable company sync",
        "description": "Sync companies from your Shopify store into SparkLayer."
      },
      "configure": "Configure"
    }
  }
}
